import { render, staticRenderFns } from "./contractorsEdit.vue?vue&type=template&id=6f4945cd&scoped=true&"
import script from "./contractorsEdit.vue?vue&type=script&lang=js&"
export * from "./contractorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4945cd",
  null
  
)

export default component.exports